








































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import _ from 'lodash';

import PublicationDetailModal from '../modals/PublicationDetailModal.vue';
import { Spinner } from 'vue-image-spinner2';
import moment from 'moment-timezone';
import DateRangePicker from 'vue2-daterange-picker';
import { publicationStoreBadge } from '@/utils';

@Component({
    name: 'publications',
    components: {
        PublicationDetailModal,
        Spinner,
        DateRangePicker
    },
    computed: {
        ...mapState('auth', ['currentUser']),
        ...mapState('publications', [
            'activePublication',
            'allPublications',
            'allPublicationsLoading',
            'publicationsPerPage',
            'publicationsPage',
            'publicationsTotal',
            'linkedProductsSummary',
            'by_stock_loading',
            'post_loading',
        ]),
        ...mapState('publications', {
            allPublications: (state: any) => {
                const allPublications = state.allPublications.map((publication: any) => {
                    publication.ml_store = publication.ml_store != null ? String(publication.ml_store) : null;
                    // listing_type
                    let listing_type;
                    switch (publication.listing_type) {
                        case 'gold_pro':
                            listing_type = 'PREMIUM';
                            break;
                        case 'gold_special':
                            listing_type = 'CLASICA';
                            break;
                        default:
                            listing_type = publication.listing_type;
                            break;
                    }

                    // logistic_type
                    let logistic_type;
                    switch (publication.logistic_type) {
                        case 'fulfillment':
                            logistic_type = 'FULFILLMENT';
                            break;
                        case 'drop_off':
                            logistic_type = 'REGULAR';
                            break;
                        case 'not_specified':
                            logistic_type = 'A ACORDAR';
                            break;
                        case 'cross_docking':
                            logistic_type = 'M-E COLECTA';
                            break;
                        case 'xd_drop_off':
                            logistic_type = 'ML-PLACES';
                            break;
                        default:
                            logistic_type = publication.logistic_type;
                            break;
                    }

                    return {
                        permalink: `https://www.mercadolibre.com.mx/publicaciones/listado/?search=${publication.id}`,
                        publication_type: publication.variations.length > 0 ? 'VARIABLE' : 'SIMPLE',
                        ...publication,
                        listing_type,
                        logistic_type,
                    };
                });
                return _.orderBy(allPublications, 'id', 'asc');
            },
        }),
    },
})
export default class Publications extends Vue {
    publicationStoreBadge = publicationStoreBadge;
    private allPublications!: any;
    private activePromo!: any;
    private allPublicationsLoading!: any;
    private publicationsPerPage!: any;
    private publicationsPage!: any;
    private publicationsTotal!: any;
    private activePublicationLoaded: boolean = false;
    private activePublication!: any;
    public linkedProductsSummary!: any;

    public by_stock_loading!: any;
    private currentUser!: any;
    public selected: any = 'all';
    stock_report: number = 0;
    flag_sku: boolean= false;

    allPublicationsHeaders = [
        { thClass: 'th', key: 'id', label: 'ID' },
        { thClass: 'th', key: 'title', label: 'Título' },
        // { thClass: 'th', key: 'publication_type', label: 'Tipo' },
        // { thClass: 'th', key: 'listing_type', label: 'Lista' },
        // { thClass: 'th', key: 'logistic_type', label: 'Gestión' },
        { thClass: 'th', key: 'last_sync_up', label: 'Sincronizado' },
        { thClass: 'th', key: 'sold_quantity', label: 'Ventas' },
        { thClass: 'th', key: 'visits', label: 'Visitas' },
        { thClass: 'th', key: 'status', label: 'Status' },
        // { thClass: 'th', key: 'autosync', label: 'AutoSync' },
        { thClass: 'th', sortable: true, key: 'price_sync', label: 'SyncPrecio' },
        { thClass: 'th', sortable: true, key: 'stock_sync', label: 'SyncStock' },
        { thClass: 'th', key: 'edit', label: '' },
    ];

    status = [
        { value: 'all', text: 'Estado', disabled: true },
        { value: 'active', text: 'Activa' },
        { value: 'paused', text: 'Inactiva' },
    ];

    public post_loading!: any;
    public isMeli: boolean = false;
    public singleDatePicker: any = 'range';
    public currentModal: any;
    public dateRange = { startDate: moment().format("YYYY-MM-DD"), endDate: moment().format("YYYY-MM-DD") };
    public customStart: string | null = null;
    public customEnd: string | null = null;

    get formattedRange() {
        if (this.dateRange.startDate && this.dateRange.endDate) {
            return `${moment(this.dateRange.startDate).format("DD/MM/YYYY")} - ${moment(this.dateRange.endDate).format("DD/MM/YYYY")}`;
        }
        return "Selecciona un rango";
    }

    onApplyCustomRange() {
        // Asegurar que las fechas están completas
        if (!this.dateRange.startDate || !this.dateRange.endDate) {
            this.$bvToast.toast('Selecciona un rango completo.', {
                title: 'Rango incompleto',
                variant: 'danger',
                solid: true
            });
            return;
        }
        const start = moment(this.dateRange.startDate);
        const end = moment(this.dateRange.endDate);
        const today = moment().endOf('day');

        // Validación: máximo 1 año
        if (end.diff(start, 'years', true) > 1) {
            this.$bvToast.toast('El rango máximo permitido es de 1 año.', {
                title: 'Rango inválido',
                variant: 'danger',
                solid: true
            });
            return;
        }

        // Validación de fecha futura
        if (end.isAfter(today)) {
            this.$bvToast.toast('No se permite seleccionar fechas futuras.', {
                title: 'Fecha inválida',
                variant: 'danger',
                solid: true
            });
            return;
        }

        this.onFilterDateRange();
        (this.$refs.dateDropdown as any).hide();
        let ml_store = this.isMeli == true ? 'Meli1' : 'Oficiales';
        this.$store.dispatch('publications/reportPosts', { start: this.customStart, end: this.customEnd, ml_store, vm: this });
    }


    onFilterDateRange() {
        this.customStart = this.dateRange.startDate;
        this.customEnd = this.dateRange.endDate;
    }

    setRange(option) {
        const today = moment();
        let start, end;

        switch (option) {
        case "today":
            start = today;
            end = today;
            break;
        case "yesterday":
            start = today.clone().subtract(1, "days");
            end = start;
            break;
        case "last7":
            start = today.clone().subtract(6, "days");
            end = today;
            break;
        case "last30":
            start = today.clone().subtract(29, "days");
            end = today;
            break;
        case "thisMonth":
            start = today.clone().startOf("month");
            end = today.clone().endOf("month");
            break;
        case "thisYear":
            start = today.clone().startOf("year");
            end = today.clone().endOf("year");
            break;
        }

        this.dateRange.startDate = start.format("YYYY-MM-DD");
        this.dateRange.endDate = end.format("YYYY-MM-DD");

        this.onApplyCustomRange();
    }

    openModal(modalId) {
        this.currentModal = modalId;
        this.$bvModal.show(modalId);
    }

    resetRange() {
      this.dateRange.startDate = null;
      this.dateRange.endDate = null;
    }


    canSee(roles: any) {
        let roleValidation = false;
        let user1Id = '8c39c042-be3d-4e7c-9f54-a840d655fe14'; // Montufar
        let user2Id = '69398834-1969-4dd8-bece-deff3c13404b'; // Dev user
        let user3Id = '91f3d64d-e790-4556-8af3-1835ca946715'; // Jocelyn
        switch (this.currentUser.role.name) {
            case 'Admin':
                roleValidation = _.intersection(roles, [this.currentUser.role.name]).length > 0;
                break;
            case 'Developer':
                roleValidation = _.intersection(roles, [this.currentUser.role.name]).length > 0;
                break;
            case 'MercadoLibre Manager':
                roleValidation = _.intersection(roles, [this.currentUser.role.name]).length > 0;
                if (this.currentUser.id != user1Id && this.currentUser.id != user2Id && this.currentUser.id != user3Id) {
                    roleValidation = false;
                }
                break;
            default:
                roleValidation = false;
                break;
        }
        return roleValidation;
    }

    setUrlPage(page: any) {
        // @ts-ignore
        this.$router.push({
            path: 'publications',
            query: {
                ...this.$route.query,
                page,
            },
        });
    }

    setUrlSort(ctx: any) {
        this.$router.push({
            path: 'publications',
            query: {
                ...this.$route.query,
                sortName: ctx.sortBy,
                sortValue: ctx.sortDesc ? 'desc' : 'asc',
            },
        });
    }

    setUrlSearch(search: string) {
        // @ts-ignore
        search = search.trim();
        this.$router.push({
            path: 'publications',
            query: {
                ...this.$route.query,
                search,
            },
        });
    }

    // onToggleAutosync(autosync: any, id: any) {
    //     this.$store.dispatch('publications/putOne', {
    //         publicationId: id,
    //         autosync,
    //         publicationData: null,
    //     });
    // }

    onCreatePublication() {

        this.activePublication.id= '';
        this.activePublication.title= '';
        this.activePublication.autosync= false;
        this.activePublication.price_sync= false;
        this.activePublication.stock_sync= false;
        this.activePublication.own_post= true;
        this.activePublication.listing_type= 'gold_special';
        this.activePublication.logistic_type= '';
        this.activePublication.linked_products_string= '[]';
        this.activePublication.linked_products= [{}];
        this.activePublication.shipment_cost= 25;
        this.activePublication.shipment_constant= 298.5;
        this.activePublication.default_shipment_cost= 25;
        this.activePublication.iva= 0.16;
        this.activePublication.category_id= '';
        this.activePublication.last_sync_up= '';
        this.activePublication.last_sync_down= '';
        this.activePublication.last_update= '';
        this.activePublication.variations= [];
        this.activePublication.category= {};
        this.activePublication.categoryCommission= '';
        this.activePublication.sync_warehouses= [];
        this.activePublication.categoryAttributes= [];
        this.activePublication.gallery= [
            {
                "id": "013324ba-35b4-4e1c-9bf1-055d051bd5e8",
                "origin": "directus",
                "url": "https://directus.prodelec.app/assets/013324ba-35b4-4e1c-9bf1-055d051bd5e8",
                "sort": null
            },
            {
                "id": "adfe3613-1be4-4ad2-9f93-df2785f3498f",
                "origin": "directus",
                "url": "https://directus.prodelec.app/assets/adfe3613-1be4-4ad2-9f93-df2785f3498f",
                "sort": null
            }
        ];
        this.activePublication.officialStore= null;
        this.activePublication.categoryPredictor= [];
        this.activePublication.visits = 0;
    
        // let id = 0;
        // this.$store.dispatch('publications/getOne', { id: id });
        this.activePublicationLoaded = true;
        setTimeout(() => {
            // @ts-ignore
            this.$bvModal.show('publication-detail-modal');
        }, 400);
    }

    onTogglePriceSync(price_sync: any, id: any, stock_sync: any) {
        this.$store.dispatch('publications/putOne', {
            publicationId: id,
            price_sync,
            stock_sync,
            publicationData: null,
        });
    }

    onToggleStockSync(stock_sync: any, id: any, price_sync: any) {
        this.$store.dispatch('publications/putOne', {
            publicationId: id,
            stock_sync,
            price_sync,
            publicationData: null,
        });
    }

    onSearchSKU(sku: boolean){
        this.flag_sku = sku;
    }

    onEditPublication(id: number) {
        this.$store.dispatch('publications/getOne', { id });
        this.activePublicationLoaded = true;
        setTimeout(() => {
            // @ts-ignore
            this.$bvModal.show('publication-detail-modal');
        }, 400);
    }

    getLinkedProductsOff() {
        this.$store.dispatch('publications/linkedProductsOff', { vm: this });
    }

    getReportByStock() {
        this.$store.dispatch('publications/reportByStock', { vm: this, stock: this.stock_report });
    }

    @Watch('$route')
    getAllPublications() {
        // @ts-ignore
        const page = this.$route.query.page || 1;
        const search = this.$route.query.search || null;
        const sortName = this.$route.query.sortName || null;
        const sortValue = this.$route.query.sortValue || null;
        const filterStatus = this.$route.query.filterStatus || null;
        const search_sku = this.flag_sku;
        this.$store.dispatch('publications/getAll', {
            page,
            search,
            sortName,
            sortValue,
            filterStatus,
            search_sku,
        });
    }

    onSelected(status) {
        this.$router.push({
            path: 'publications',
            query: {
                ...this.$route.query,
                filterStatus: status,
            },
        });
    }

    mounted() {
        this.getAllPublications();
    }
    copyToClipboard(publication: any) {
        let code = publication.substring(3);
        let link = "https://articulo.mercadolibre.com.mx/MLM-"+ code;
        navigator.clipboard.writeText(link);
        this.$bvToast.toast('Se ha copiado el link de la publicación ' + publication, {
                    title: `Publicación copiada`,
                    variant: 'info',
                    toaster: 'b-toaster-top-center',
                    autoHideDelay: 5000,
                });
    }
}
